interface IAuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: IAuthProviderProps) => {
  // TODO: Implement authentication logic
  return <>{children}</>;
};
